import React, { useState, useEffect } from "react";
import back5 from "../../../../../imgs/back5.png";
import pic from "../../../../../imgs/company.svg";
import { Pagination } from "antd";
import axios from "axios";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import { useSelector } from "react-redux";
import { FaTimes } from "react-icons/fa";
import ErrorModal from "../../../../Merchant/Modals/errorModal";
import SuccessModal from "../../../../modals/successModal";
import { useNavigate } from "react-router-dom";
let file;
const Main = () => {
  const router = useNavigate();
  const [data, setData] = useState([]);
  const [dataS, setDataS] = useState([]);
  const [role, setRole] = useState(null);
  const [ip, setIp] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPagesS, setTotalPagesS] = useState(0);
  const [cancelTokenSource, setCancelTokenSource] = useState(null);
  const [refetch, setRefetch] = useState(false);
  const [page, setPage] = useState(1);
  const [pageS, setPageS] = useState(1);
  const dataUser = useSelector((state) => state.dataUser);
  const batchDetails = useSelector((state) => state.batchDetails);
  const [addModal, setAddModal] = useState(false);
  const [err, setErr] = useState("");
  const [emailValue, setEmailValue] = useState(false);
  const [gid, setGid] = useState("");
  const [phone, setPhone] = useState("");
  const [emailValueS, setEmailValueS] = useState("");
  const [gidS, setGidS] = useState("");
  const [phoneS, setPhoneS] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [phoneNoo, setPhoneNoo] = useState("");
  const [show, setShow] = useState("");
  const [show1, setShow1] = useState("");
  const [contactMethod, setContactMethod] = useState("gid");
  const [message, setMessage] = useState("");
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [selectedMembersR, setSelectedMembersR] = useState([]);
  const [search, setSearch] = useState("");
  const token = useSelector((state) => state.token);
  const user = useSelector((state) => state.user);

  const handleSelectMember = (id) => {
    setSelectedMembers((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((selectedId) => selectedId !== id)
        : [...prevSelected, id]
    );
  };
  const handleSelectMemberR = (id) => {
    setSelectedMembersR((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((selectedId) => selectedId !== id)
        : [...prevSelected, id]
    );
  };
  const handleOptionChange = (event) => {
    setContactMethod(event.target.value);
    if (event.target.value === "phone") {
      setEmailValueS("");
      setEmailValue("");
      setGid("");
      setGidS("");
    }
    if (event.target.value === "email") {
      setGid("");
      setPhone("");
      setCountryCode("");
      setPhoneNoo("");
      setGidS("");
    }
    if (event.target.value === "gid") {
      setEmailValue("");
      setEmailValueS("");
      setPhone("");
      setCountryCode("");
      setPhoneNoo("");
    }
    if (event.target.value === "import") {
      setEmailValue("");
      setPhone("");
      setCountryCode("");
      setPhoneNoo("");
    }
    if (event.target.value === "batch") {
      setEmailValue("");
      setPhone("");
      setCountryCode("");
      setPhoneNoo("");
    }
  };
  // const handleChange = (setState, check) => (event) => {
  //   if (check === "tt") {
  //     setPhone(event);
  //     if (event) {
  //       const wow = parsePhoneNumber(event);
  //       if (wow) {
  //         let count = wow.countryCallingCode;
  //         let num = wow.nationalNumber;
  //         setCountryCode(count);
  //         setPhoneNoo(num);
  //       }
  //     }
  //   }
  //   if (check === "ts") {
  //     setPhoneS(event);
  //   } else {
  //     setState(event.target.value);
  //   }
  // };

  const handleChange = (setState, check) => (event) => {
    if (check === "tt") {
      setPhone(event);
      if (event) {
        const wow = parsePhoneNumber(event);
        if (wow) {
          let count = wow.countryCallingCode;
          let num = wow.nationalNumber;
          setCountryCode(count);
          setPhoneNoo(num);
        }
      }
    } else {
      setState(event.target.value);
    }
  };
  console.log("Test", batchDetails);
  const pageHandler = (e) => {
    setPage(e);
  };
  const pageHandlerS = (e) => {
    setPageS(e);
  };

  useEffect(() => {
    if (gid || phone || emailValueS || gidS || phoneS) {
      const delay = 1000;
      const timeoutId = setTimeout(() => {
        if (cancelTokenSource) {
          cancelTokenSource.cancel("Operation canceled by the user.");
        }

        const newCancelTokenSource = axios.CancelToken.source();
        setCancelTokenSource(newCancelTokenSource);

        const params = {
          // limit: 6,
          // skip: (page - 1) * 6,
          // page: page,
          // sortBy: "createdAt:desc",
          ...(emailValueS && { search: emailValueS }),
          // ...(phoneS && { search: `${phoneS}` }),
          ...(gidS && { search: gidS }),
          ...(countryCode &&
            phoneNoo && { countryCode: `+${countryCode}`, phoneNo: phoneNoo }),
        };

        Search(params, newCancelTokenSource);
      }, delay);

      return () => {
        clearTimeout(timeoutId);

        if (cancelTokenSource) {
          cancelTokenSource.cancel("Operation canceled by the user.");
        }
      };
    }
  }, [refetch, pageS, emailValueS, phoneS, gidS, countryCode, phoneNoo]);
  const Search = (params, cancelTokenSource) => {
    // v1/users/search
    const api =
      user === "merchant-owner" ? "v1/common-users/merch" : "v1/common-users";
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/${api}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
        cancelToken: cancelTokenSource.token,
      })
      .then((res) => {
        setDataS(res?.data?.rows);
        setTotalPagesS(res?.data?.totalPages);
      })
      .catch((err) => {
        setDataS([]);
        console.log(err);
      });
  };
  useEffect(() => {
    console.log("Data", dataS);
    console.log("Data", phoneS);
  }, [dataS, phoneS]);

  useEffect(() => {
    const delay = 1000;
    const timeoutId = setTimeout(() => {
      if (cancelTokenSource) {
        cancelTokenSource.cancel("Operation canceled by the user.");
      }

      const newCancelTokenSource = axios.CancelToken.source();
      setCancelTokenSource(newCancelTokenSource);

      const params = {
        limit: 9,
        skip: (page - 1) * 9,
        page: page,
        sortBy: "createdAt:desc",
      };

      fetchAllAccess(params, newCancelTokenSource);
    }, delay);

    return () => {
      clearTimeout(timeoutId);

      if (cancelTokenSource) {
        cancelTokenSource.cancel("Operation canceled by the user.");
      }
    };
  }, [refetch, page]);

  const fetchAllAccess = (params, cancelTokenSource) => {
    const api =
      user === "merchant-owner"
        ? "v1/event-batch/merch-joinee-members"
        : "v1/event-batch/joinee-members";
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/${api}/${batchDetails?.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
        cancelToken: cancelTokenSource.token,
      })
      .then((res) => {
        setData(res?.data?.rows);
        setTotalPages(res?.data?.totalPages);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const AddMember = () => {
    setAddModal(false);
    const api =
      user === "merchant-owner"
        ? "v1/event-batch/merch-event-batch-joinee"
        : "v1/event-batch/joinee";
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/${api}`,
        {
          eventBatchId: batchDetails?.id,
          eventBatchJoinees: selectedMembers,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        setRefetch(!refetch);
        setMessage("Member Added Successfully");
        setShow(true);
        setSelectedMembers([]);
      })
      .catch((err) => {
        setErr(err?.response?.data?.message);
        setShow1(true);
      });
  };
  const remove = () => {
    const api =
      user === "merchant-owner"
        ? "v1/event-batch/remove/merch-event-batch-joinee"
        : "v1/event-batch/remove/joinee";
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/${api}`,
        {
          eventBatchId: batchDetails?.id,
          eventBatchJoinees: selectedMembersR,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        setRefetch(!refetch);
        setMessage("Member Removed Successfully");
        setSelectedMembersR([]);
      })
      .catch((err) => {
        setErr(err?.response?.data?.message);
        setShow1(true);
      });
  };

  return (
    <div className="flex items-center justify-center mt-4 flex-col">
      <div
        className={`${
          user === "merchant-owner"
            ? "md:w-[90%] w-full p-4"
            : "md:w-[85%] w-full p-4"
        }`}
      >
        <div
          className="pl-2 pr-2  mt-[1rem] sm:mt-[0rem]"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <div className="flex justify-between items-center mt-4">
              <div className="top-[2.8] cursor-pointer flex items-center  gap-2 justify-center">
                <img
                  className="sm:w-[1.7rem] w-[1.2rem]"
                  src={back5}
                  alt=""
                  onClick={() => {
                    if (user === "merchant-owner") {
                      router("/Merchant/EventDetails/Batch");
                      return;
                    }
                    router("/EventDetails/Batch");
                  }}
                />
                <h2 className="font-bold sm:text-[1.8rem] text-[1.4rem]">
                  Batch
                </h2>
              </div>
              <button
                className={` text-white bg-primary pl-5 pr-5 pt-2 pb-2 rounded-lg sm:text-lg text-md`}
                onClick={() => {
                  setIp("");
                  setRole(null);
                  setAddModal(true);
                  setShowPopup(true);
                }}
              >
                Add Member
              </button>
            </div>
          </div>
        </div>

        <div className="lg:p-12 bg-slate-50 sm:ml-0 w-full  w-full mt-[2rem] mb-8 bg-slate-50 p-[35px] rounded-2xl relative">
          <div className="flex items-center gap-4 w-full rounded-md bg-white shadow-md p-4">
            <img
              src={batchDetails.image}
              alt={batchDetails.name}
              className="w-20 h-20 rounded-full cursor-pointer"
            />
            <div className="flex flex-col gap-1">
              <p className="cursor-pointer text-lg font-semibold">
                {batchDetails.name}
              </p>
              <p className="cursor-pointer">{batchDetails.detail}</p>
            </div>
          </div>

          <div className="w-full flex mt-4 items-center justify-between">
            <h1 className="flex text-lg font-semibold">Members:</h1>
            {data?.length > 0 && (
              <h1
                onClick={() => {
                  if (selectedMembersR.length === 0) {
                    setErr("Please Select members to remove.");
                    setShow1(true);
                  } else {
                    remove();
                  }
                }}
                className="flex text-red-600 hover:underline cursor-pointer font-semibold"
              >
                Remove Members
              </h1>
            )}
          </div>
          {data?.length === 0 && (
            <p className="mt-4 text-center cursor-pointer font-semibold">
              No members added yet.
            </p>
          )}
          {data?.length > 0 && (
            <div className="grid grid-cols-1 mt-3 w-full sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
              {data.map((item) => (
                <div
                  key={item.id}
                  className="bg-white flex items-center hover:bg-gray-200 cursor-pointer shadow-md relative p-4 gap-3 rounded-md"
                >
                  <div>
                    <img
                      src={item?.user?.person?.image}
                      alt={item?.user?.person?.firstName}
                      className="w-16 h-16 rounded-full cursor-pointer"
                    />
                  </div>
                  <div className="flex-grow">
                    <p className="cursor-pointer font-semibold">
                      {item?.user?.person?.firstName}{" "}
                      {item?.user?.person?.lastName}
                    </p>
                    {item?.user?.gid && (
                      <h1 className="text-[0.9rem] font-semibold text-primary capitalize">
                        {"GID:"} {item?.user?.gid ? item?.user?.gid : ""}
                      </h1>
                    )}
                    <h1 className="text-[0.9rem] font-semibold text-primary capitalize">
                      {item?.user?.email ? item?.user?.email : ""}
                    </h1>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      checked={selectedMembersR.includes(item.userId)}
                      onChange={() => handleSelectMemberR(item.userId)}
                      className="cursor-pointer"
                    />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className={`flex justify-center mt-7`}>
          <Pagination
            defaultCurrent={1}
            total={totalPages * 10}
            showSizeChanger={false}
            onChange={pageHandler}
            current={page}
          />
        </div>
      </div>
      {showPopup && (
        <div className="fixed inset-0 z-100 flex items-center justify-center bg-black bg-opacity-50">
          <div className="my-4 relative sm:w-[60%] w-full w-full py-8 gap-3 px-6 bg-[#F7F7F7] max-h-[90%] overflow-auto rounded-md">
            <FaTimes
              onClick={() => {
                setShowPopup(false);
                setGidS("");
                setPhoneS("");
                setEmailValue("");
              }}
              className="absolute top-2 right-2 text-red-600 text-lg cursor-pointer"
            />
            <h1 className="font-semibold text-[1.8rem] mb-4 w-full text-center">
              Add Member
            </h1>
            <div className="w-full">
              <div className="flex gap-4">
                <div className="mb-2 flex items-center">
                  <input
                    type="radio"
                    id="gidOption"
                    name="contactMethod"
                    value="gid"
                    className="mr-2 h-4 w-4 cursor-pointer text-green-500 focus:ring-green-400 focus:ring-opacity-50 rounded-full custom-radio"
                    checked={contactMethod === "gid"}
                    onChange={handleOptionChange}
                  />
                  <label
                    htmlFor="gidOption"
                    className="cursor-pointer text-sm inline-flex items-center ml-2"
                  >
                    GID
                  </label>
                </div>
                <div className="mb-2 flex items-center">
                  <input
                    type="radio"
                    id="phoneOption"
                    name="contactMethod"
                    value="phone"
                    className="mr-2 h-4 w-4 cursor-pointer text-green-500 focus:ring-green-400 focus:ring-opacity-50 rounded-full custom-radio"
                    checked={contactMethod === "phone"}
                    onChange={handleOptionChange}
                  />
                  <label
                    htmlFor="phoneOption"
                    className="cursor-pointer text-sm inline-flex items-center ml-2"
                  >
                    Phone Number
                  </label>
                </div>

                <div className="mb-2 flex items-center">
                  <input
                    type="radio"
                    id="emailOption"
                    name="contactMethod"
                    value="email"
                    className="mr-2 h-4 w-4 cursor-pointer text-green-500 focus:ring-green-400 focus:ring-opacity-50 rounded-full custom-radio"
                    checked={contactMethod === "email"}
                    onChange={handleOptionChange}
                  />
                  <label
                    htmlFor="emailOption"
                    className="cursor-pointer text-sm inline-flex items-center ml-2"
                  >
                    Email
                  </label>
                </div>
              </div>
              <div className="flex gap-1 items-center">
                {contactMethod === "gid" && (
                  <div className="w-full mb-3 mt-2">
                    <input
                      type="text"
                      name=""
                      onChange={(e) => setGidS(e.target.value)}
                      placeholder="Enter GID"
                      className="lg:text-[1.1rem] w-[100%] border border-gray-300  bg-white rounded-[0.5rem] p-2"
                    />
                  </div>
                )}
                {contactMethod === "phone" && (
                  <PhoneInput
                    placeholder="Enter phone number"
                    defaultCountry="GY"
                    international
                    value={phoneS}
                    onChange={handleChange(setPhoneNoo, "tt")}
                    countryCallingCodeEditable={false}
                    className=".PhoneInputCountryIcon .PhoneInputCountrySelectArrow w-full"
                  />
                )}

                {contactMethod === "email" && (
                  <div className="w-full mb-3 mt-2">
                    <input
                      type="text"
                      name=""
                      value={emailValueS}
                      onChange={(e) => setEmailValueS(e.target.value)}
                      placeholder="Enter Email"
                      className="lg:text-[1.1rem] w-[100%] border border-gray-300  bg-white rounded-[0.5rem] p-2"
                    />
                  </div>
                )}
              </div>
              <h1 className="flex text-lg font-semibold">Searched Members:</h1>
              <div>
                {dataS?.length === 0 && (
                  <p className="mt-4 text-center cursor-pointer font-semibold">
                    No searched members.
                  </p>
                )}
                {dataS?.length > 0 && (
                  <div className="flex flex-wrap mt-3 w-full gap-2">
                    {dataS.map((item) => (
                      <div
                        key={item.id}
                        className="bg-white flex items-center hover:bg-gray-200 cursor-pointer shadow-md relative p-4 gap-3 rounded-md"
                      >
                        <div className="w-16 h-16 flex-shrink-0">
                          <img
                            src={
                              item?.person?.image
                                ? item?.person?.image
                                : "data:image/jpeg;base64,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"
                            }
                            alt={item?.person?.firstName}
                            className="w-16 h-16 rounded-full cursor-pointer object-cover"
                          />
                        </div>
                        <div className="flex-grow">
                          <p className="cursor-pointer font-semibold">
                            {item?.person?.firstName} {item?.person?.lastName}
                          </p>
                          <h1
                            className={`${
                              item?.gid
                                ? "text-[0.9rem] font-semibold text-primary capitalize"
                                : "hidden"
                            }`}
                          >
                            {"GID:"} {item?.gid ? item?.gid : ""}
                          </h1>
                          <h1 className="text-[0.9rem] font-semibold text-primary">
                            {item?.email ? item?.email : ""}
                          </h1>
                          <h1 className="text-[0.9rem] font-semibold text-gray-700 capitalize">
                            {/* {"Role:"}{" "} */}
                            <span className="text-[0.9rem] font-semibold  capitalize">
                              {item?.roles ? item?.roles?.[0] : ""}
                            </span>
                          </h1>
                        </div>
                        <div>
                          <input
                            type="checkbox"
                            checked={selectedMembers.includes(item.id)}
                            onChange={() => handleSelectMember(item.id)}
                            className="cursor-pointer"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {/* {dataS?.length > 0 && (
                  <div className={`flex justify-center mt-4`}>
                    <Pagination
                      defaultCurrent={1}
                      total={totalPagesS * 10}
                      showSizeChanger={false}
                      onChange={pageHandlerS}
                      current={pageS}
                    />
                  </div>
                )} */}
              </div>
              <div className="w-full flex items-center mt-8 gap-4 justify-center">
                <button
                  onClick={() => {
                    setShowPopup(false);
                    setGidS("");
                    setEmailValueS("");
                    setPhoneS("");
                  }}
                  className={`text-white w-[40%] bg-red-600 pl-5 pr-5 pt-1 pb-1 rounded-lg sm:text-lg text-md `}
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    if (selectedMembers?.length === 0) {
                      setErr("Please Search and select members to add.");
                      setShow1(true);
                    } else AddMember();
                  }}
                  className={`text-white w-[40%] bg-primary pl-5 pr-5 pt-1 pb-1 rounded-lg sm:text-lg text-md `}
                >
                  ADD
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {show1 && <ErrorModal show={show1} setShow={setShow1} err={err} />}
      {show && <SuccessModal show={show} setShow={setShow} message={message} />}
    </div>
  );
};

export default Main;
